import { useEffect } from "react";
import { useSelector } from "react-redux";

const CustomHook = (refTab = null, refList = null) => {
  const scrollTab = refTab;
  const divs = refList;
  const activeTab = useSelector((state) => state.activeTab);

  useEffect(() => {
    if (scrollTab.current.classList.contains(activeTab)) {
      const componentNode = scrollTab.current;
      componentNode.scrollIntoView({ behavior: "smooth" });
    }
   
  }, [activeTab]);
};

export default CustomHook;
